import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import NewSectionForm from 'core/modules/components/forms/NewSectionForm';

const DialogNewSection = ({ t, open, onClose, onSuccess, dataEdit, isPublisherMode, lesson }) => {
  return (
    <Dialog title={dataEdit?.guid ? t('Edit section') : t('Add new section')} isOpen={open} className={'dialog-new-lesson'} onClose={onClose} size="s">
      <NewSectionForm onCancel={onClose} onSuccess={onSuccess} dataEdit={dataEdit} isPublisherMode={isPublisherMode} lesson={lesson} />
    </Dialog>
  );
};

DialogNewSection.propTypes = {
  t: PropTypes.func,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
  dataEdit: PropTypes.object,
  isPublisherMode: PropTypes.bool,
  lesson: PropTypes.object,
};

DialogNewSection.defaultProps = {
  onClose: function () {},
  onSuccess: function () {},
  open: false,
};

export default withTranslation(['new-lesson'])(DialogNewSection);
